// @ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext.jsx';
import { SearchDialog } from './SearchDialog.jsx';
import { Menu as MenuIcon, Search, X } from 'lucide-react';

export function SiteHeader() {
  const { locale, setLocale, t, enabledLocales } = useI18n();
  const [open, setOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const searchButton = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const onEscape = event => { if (event.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onEscape); return () => document.removeEventListener('keydown', onEscape);
  }, [open]);
  function closeSearch() { setSearchOpen(false); requestAnimationFrame(() => searchButton.current?.focus()); }
  const supplyLabel = {
    ru: 'Расходники и запчасти',
    uz: 'Sarf materiallar',
    en: 'Consumables & parts',
  }[locale];
  const links = [
    ['/', t.home],
    ['/solutions', t.solutions], ['/equipment', t.equipment], ['/software/tracora', 'Tracora'],
    ['/engineering-center', t.engineering], ['/service', t.service],
    ['/consumables-parts', supplyLabel], ['/about', t.about], ['/contacts', t.contacts],
  ];
  return <>
    {open && <button
      type="button"
      className="nav-backdrop"
      aria-label={t.closeMenu}
      onClick={() => setOpen(false)}
    />}
    <header className="header" data-testid="site-header">
    <div className="shell header-inner">
      <Link className="brand" to="/" aria-label={`ANLEXX — ${t.home}`}>
        <span className="logo-frame" aria-hidden="true"><img src="/images/anlexx-logo.jpg" alt="" /></span>
        <span><strong>ANLEXX</strong><small>Industrial engineering</small></span>
      </Link>
      <nav className={open ? 'nav open' : 'nav'} aria-label={t.primaryNav} id="main-navigation">
        {links.map(([href, label]) => <NavLink end={href === '/'} key={href} to={href} onClick={() => setOpen(false)}>{label}</NavLink>)}
        <div className="mobile-languages" role="group" aria-label={t.mobileLanguage}>{enabledLocales.map(item => <button key={item} type="button" aria-pressed={locale === item} className={locale === item ? 'active' : ''} onClick={() => setLocale(item)}>{item.toUpperCase()}</button>)}</div>
      </nav>
      <div className="header-tools">
        <button ref={searchButton} type="button" className="header-search" aria-label={t.openSearch} onClick={() => setSearchOpen(true)}><Search aria-hidden="true"/></button>
        <div className="languages" role="group" aria-label={t.language}>{enabledLocales.map(item => <button key={item} type="button" aria-pressed={locale === item} className={locale === item ? 'active' : ''} onClick={() => setLocale(item)}>{item.toUpperCase()}</button>)}</div>
        <Link className="nav-cta" to="/contacts?type=engineering">{t.start}</Link>
        <button type="button" className="menu" aria-label={open ? t.closeMenu : t.openMenu} aria-expanded={open} aria-controls="main-navigation" onClick={() => setOpen(value => !value)}>{open ? <X aria-hidden="true"/> : <MenuIcon aria-hidden="true"/>}</button>
      </div>
    </div>
    <SearchDialog open={searchOpen} onClose={closeSearch}/>
    </header>
  </>;
}
